"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getNonOptionsFromChildren = exports.getOptionsFromChildren = exports.isOptionValueSelected = exports.isOption = void 0;

var _react = _interopRequireDefault(require("react"));

var _selectOption = _interopRequireDefault(require("./select-option"));

var _isElementOf = _interopRequireDefault(require("./../_utils/is-element-of"));

var _filterPropsByPrefix = _interopRequireDefault(require("./../_utils/filter-props-by-prefix"));

var isOption = (0, _isElementOf["default"])(_selectOption["default"]);
exports.isOption = isOption;

var isOptionValueSelected = function isOptionValueSelected(selectedValue, optionValue) {
  return Array.isArray(selectedValue) ? selectedValue.indexOf(optionValue) !== -1 : selectedValue === optionValue;
};

exports.isOptionValueSelected = isOptionValueSelected;

var getOptionsFromChildren = function getOptionsFromChildren(children) {
  return _react["default"].Children.toArray(children).filter(isOption).map(function (child, index) {
    return {
      index: index,
      label: child.props.label.toString(),
      value: child.props.value,
      children: child.props.children,
      disabled: child.props.disabled,
      passThroughProps: (0, _filterPropsByPrefix["default"])(child.props, ["data-"])
    };
  });
};

exports.getOptionsFromChildren = getOptionsFromChildren;

var getNonOptionsFromChildren = function getNonOptionsFromChildren(children) {
  return _react["default"].Children.toArray(children).filter(function (child) {
    return child && !isOption(child);
  });
};

exports.getNonOptionsFromChildren = getNonOptionsFromChildren;